<section class="db-trial-subscription-plan">
  <div class="main-body">
    <div class="sidebar">
      <div class="title">{{ 'text_currentPlan' | dbText}}</div>
      <db-trial-plan-sidebar [freeDaysCount]="freeDays" [subscription]="userSubscription"></db-trial-plan-sidebar>
    </div>
    <div class="plan-details">
      <div class="title">{{ 'text_planDetails' | dbText}}</div>
      <db-trial-plan-details [daysUntilNext]="daysUntilNext"
                             [freeDaysCount]="freeDays"
                             [usedAiCredits]="vibeLimitationData ?? usedAiCredits$|async"
                             [percentageLeft]="percentageLeft"
      (onUpgrade)="onUpgradeClick.emit()"></db-trial-plan-details>
    </div>
  </div>
</section>
